const visible = (state) => state.visible;
const text = (state) => state.text;
const status = (state) => state.status;

export default {
  visible,
  text,
  status,
};
